import dayjs from 'dayjs';
/**
 * @param {Object} vueInstance : this
 * @param {String} type : Toast type ['success', 'danger']
 * @param {String} message : Toast message
 */
function getRetrainModelName(templateModelName) {
	let tempName = templateModelName.replace(/\.[^/.]+$/, '');
	if (tempName.match(/-\d{8}_\d{6}/)) {
		tempName = tempName.replace(/-\d{8}_\d{6}/, '');
	}
	tempName = `${tempName}-${dayjs().format('YYYYMMDD_hhmmss')}`;

	return tempName;
}

export default getRetrainModelName;
